export default {
  name: 'spruce',

  anchor: '#1034a6',
  anchorVisited: '#440381',
  borderDark: '#477b5e',
  borderDarkest: '#001004',
  borderLight: '#b0d2bb',
  borderLightest: '#cdead2',
  canvas: '#fcfff6',
  canvasText: '#050608',
  canvasTextDisabled: '#3d5367',
  canvasTextDisabledShadow: '#cdead2',
  canvasTextInvert: '#fcfff6',
  checkmark: '#050608',
  checkmarkDisabled: '#477b5e',
  flatDark: '#9e9e9e',
  flatLight: '#d8d8d8',
  focusSecondary: '#fefe03',
  headerBackground: '#3d9961',
  headerNotActiveBackground: '#807f80',
  headerNotActiveText: '#d4deda',
  headerText: '#fcfff6',
  hoverBackground: '#3d9961',
  material: '#99c9a8',
  materialDark: '#9a9e9c',
  materialText: '#050608',
  materialTextDisabled: '#3d5367',
  materialTextDisabledShadow: '#cdead2',
  materialTextInvert: '#fcfff6',
  progress: '#3d9961',
  tooltip: '#fefbcc'
};
